import React from 'react';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import AOS from 'aos';
import '../Pages/Style.css';

const Career = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,  // animation time in ms
            once: true,      // animate only once when scrolling down
            easing: 'ease-in-out',
            offset: 120,
        });
    }, []);

    return (
        <div id='content' >
            {/* Background image section with left text */}
            <div
                className="home-background d-flex align-items-start"
                id="career-background"
                style={{
                    backgroundImage: `url('/Photos/vertical-shot-smiling-girl-student-asian-woman-sits-stairs-university-campus-drinks.jpg')`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '450px',
                    color: 'white' // optional: white text for better contrast
                }}
            >
                <div className="w-100 text-end p-4 pt-5 me-4">
                    <h1 className="text-whitee">Career</h1>
                </div>
            </div>
            <div className="container py-5" data-aos="fade-up">
                <h3 className="text-primary mb-4" id='about-us'>Careers at Our Company</h3>

                <div className="row align-items-center">
                    {/* Image Section */}
                    <div className="col-md-5 mb-4 mb-md-0">
                        <img
                            src="https://blog.comparasoftware.com/wp-content/uploads/2020/08/Comunicacion_interna.png"
                            alt="Team working"
                            className="img-fluid rounded shadow"

                        />
                    </div>

                    {/* Text Section */}
                    <div className="col-md-7">
                        <p>
                            “Careers at Delight Consultancy offer more than just a job—they provide an opportunity to grow, innovate, and make an impact. We believe in empowering talent by fostering a culture of collaboration, learning, and professional excellence. At Delight Consultancy, you’ll work alongside industry experts, tackle challenging projects, and contribute to meaningful solutions that drive success for our clients. Whether you’re an experienced professional or just starting your career, we provide the tools, guidance, and support you need to achieve your full potential. Join us at Delight Consultancy and be part of a team that’s shaping the future of business.”

                        </p>
                        <a href="https://delightconsultancy.in/job" target='_blank' rel="noreferrer"><button className='contact-btn'>VIEW OPEN POSITIONS </button></a>



                    </div>
                </div>
                <div className="container my-5" data-aos="fade-up" id='our-workk'>
                    <div className="row" id='our-wor'>
                        <div className="text-center mb-4">
                            {/* <h2 className="about-heading"> our work </h2>
                        <h3 className="text">Get to know who we are and what drives us forward.</h3> */}
                        </div>

                        {/* Vision */}
                        <div className="col-md-4 mb-4">
                            <div className="card h-100 shadow-sm">
                                <img
                                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQQ4C4PDadp8TmKZ-NySJwgZLkXl6ntzvP485gI5FIzEZF1829idTMaS6dy-OJD08IIoCE&usqp=CAU"
                                    className="card-img-top"
                                    alt="Vision"
                                    height={300}
                                />
                                <div className="card-body">
                                    <h5 className="card-title fw-bold">Our Vision</h5>
                                    <p className="card-text">
                                        At Delight Consultancy, we envision a future where talent meets opportunity seamlessly. Our goal is to bridge the gap between great companies and great people.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Values */}
                        <div className="col-md-4 mb-4">
                            <div className="card h-100 shadow-sm">
                                <img
                                    src="https://media.licdn.com/dms/image/v2/D5612AQGpIRBEfcu4xg/article-cover_image-shrink_600_2000/article-cover_image-shrink_600_2000/0/1696007466436?e=2147483647&v=beta&t=60LdytJjb0AGnxnCFoc7alBtuan8eueLxmZCixa_s0g"
                                    className="card-img-top"
                                    alt="Values"
                                    height={300}
                                />
                                <div className="card-body">
                                    <h5 className="card-title fw-bold">Our Values</h5>
                                    <p className="card-text">
                                        Integrity, transparency, and excellence guide every step of our process. We work with purpose, passion, and a commitment to creating meaningful career paths.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Team */}
                        <div className="col-md-4 mb-4">
                            <div className="card h-100 shadow-sm">
                                <img
                                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQI29BHGYZUWYXZAHrCqqR1QGeubVildLVdEBDl_zNx9zTIh6lf4XpBDbbSgj-ui8J70c0&usqp=CAU"
                                    className="card-img-top"
                                    alt="Team"
                                    height={300}
                                />
                                <div className="card-body">
                                    <h5 className="card-title fw-bold">Meet the Team</h5>
                                    <p className="card-text">
                                        Our diverse team of experts brings together experience, innovation, and empathy. We’re here to support job seekers and employers every step of the way.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
            <div className='container-fluid' id="counter-part">
                <div className='container' data-aos="fade-up">
                    <h2 className='counter-head'>Our employees enjoy a healthy work-life balance, ongoing training, and career advancement opportunities.</h2>
                    <div className='container'>
                        <p id='who'></p>
                    </div>


                </div>
            </div>
            <div className='container-fluid' id="wedo-page" data-aos="fade-up">
                <div className="container my-5">
                    <h3 className='text-center'>Benefits</h3>
                    <div className="row align-items-center">
                        {/* Left side content */}
                        <div className="col-md-6">
                            <img
                                src="https://web.soluprime.io/blog/content/images/2021/01/27-eNER.png"
                                alt="Office"
                                className="img-fluid rounded"
                                style={{ maxHeight: '400px', width: '100%', objectFit: 'cover' }}

                            />
                        </div>
                        <div className="col-md-6">
                            <h3 className='business-head'>Professional development</h3>
                            <p>At Delight Consultancy, professional development is at the heart of everything we do. We are committed to helping our team members grow their skills, expand their knowledge, and achieve their career aspirations. Through tailored training programs, mentorship opportunities, and hands-on project experiences, we create an environment that fosters continuous learning and growth. Whether it’s mastering new technologies, developing leadership capabilities, or gaining industry insights, Delight Consultancy empowers you to reach new heights in your professional journey. Together, we invest in your success, because your growth is our strength.</p>
                        </div>
                        <div className="col-md-6">
                            <h3 className='med-head'>Medical</h3>
                            <p>At Delight Consultancy, we are dedicated to transforming the medical industry through innovative solutions and expert guidance. Whether it’s streamlining healthcare operations, enhancing patient care, or supporting medical professionals with cutting-edge strategies, we provide tailored services that address the unique challenges of the sector. Our team works closely with healthcare providers, pharmaceutical companies, and medical institutions to deliver sustainable, results-driven outcomes. With a commitment to excellence and a deep understanding of the industry, Delight Consultancy is your trusted partner in advancing healthcare for a better tomorrow.</p>
                        </div>
                        <div className="col-md-6">
                            <h3 className='compen-head'>Compensation</h3>
                            <p>At Delight Consultancy, we believe in recognizing and rewarding the talent that drives our success. Our compensation packages are designed to be competitive, transparent, and aligned with industry standards, ensuring that our team members feel valued for their contributions. Beyond a base salary, we offer performance-based incentives, comprehensive benefits, and opportunities for growth and advancement. We’re committed to creating a workplace where hard work is rewarded, and employees can thrive both personally and professionally.</p>
                        </div>
                        <div className="col">
                            <h3 className='compen-head'>Parental leave</h3>
                            <p>At Delight Consultancy, we understand the importance of work-life balance, especially during significant life events like the arrival of a child. Our parental leave policy is designed to support both parents with paid leave, allowing them the time to bond with their newborn or adopted child without the stress of financial concern. We provide flexible options to ensure that our employees can prioritize family while maintaining career growth. With a focus on fostering a supportive and inclusive environment, Delight Consultancy is dedicated to making sure that both personal and professional lives are well-balanced and cared for.</p>
                        </div>




                    </div>
                </div>
            </div>
            <div className='container-fluid' id="counter-part">
                <div className='container' data-aos="fade-up">
                    <h2 className='counter-head'>We believe in empowering individuals, encouraging innovation, and supporting continuous growth.</h2>
                    <div className='container'>
                        <p id='who'></p>
                    </div>


                </div>
            </div>
            <div className="container my-5" data-aos="fade-up" id='our-workk'>
                <div className="row" id='our-workk'>
                    <div className="text-center mb-4">
                        <h3 className="about-heading"> Our Culture </h3>
                        {/* <h3 className="text">Get to know who we are and what drives us forward.</h3> */}
                    </div>

                    {/* Vision */}
                    <div className="col-md-6">
                        <h2 className='business-head'>Work-life balance</h2>
                        <p>At Delight Consultancy, we prioritize a healthy work-life balance to ensure our team members can thrive both professionally and personally. We recognize that success at work should not come at the expense of personal well-being, which is why we offer flexible work schedules, remote work options, and generous time-off policies. Our goal is to create an environment where employees can be fully engaged at work while also having time to enjoy their personal lives, pursue hobbies, and spend quality time with loved ones. At Delight Consultancy, we believe that when our employees are happy and balanced, they are more productive and motivated to achieve their best.</p>
                    </div>

                    <div className="col-md-6">
                        <h3 className='business-head'>Diversity and inclusion</h3>
                        <p>At Delight Consultancy, we are committed to fostering a diverse and inclusive workplace where everyone feels valued, respected, and empowered. We believe that a team made up of individuals with different backgrounds, perspectives, and experiences drives innovation and creativity, allowing us to deliver better solutions to our clients. By promoting diversity in all its forms—whether it’s race, gender, age, ethnicity, or thought—we create an environment where everyone has the opportunity to thrive. Inclusion is not just a policy for us; it’s a core value that strengthens our culture, fosters collaboration, and drives success.</p>
                    </div>

                    <div className="col-md-6">
                        <h3 className='business-head'>Work hard, play hard</h3>
                        <p>At Delight Consultancy, we believe in balancing hard work with well-deserved relaxation and fun. We strive for excellence in everything we do, pushing ourselves to deliver outstanding results and exceed expectations for our clients. But we also understand the importance of taking time to recharge, celebrate achievements, and build strong team connections. Whether it’s through team-building events, social gatherings, or just enjoying a casual moment together, we embrace the ‘work hard, play hard’ mentality to ensure our workplace remains energized, collaborative, and full of positive momentum.</p>
                    </div>
                    <div className="col-md-6">
                        <h3 className='business-head'>Make an impact</h3>
                        <p>At Delight Consultancy, we are driven by a shared passion to make a lasting impact—both for our clients and in the communities we serve. We believe that through innovative solutions, thoughtful strategies, and unwavering commitment, we can help businesses grow, solve complex challenges, and create positive change. Every project we take on is an opportunity to make a difference, and we empower our team to think creatively, act boldly, and deliver results that matter. At Delight Consultancy, we don’t just aim to meet expectations; we strive to exceed them, leaving a meaningful imprint on every endeavor we undertake.</p>
                    </div>
                    <div className="col-md-6">
                        <h3 className='business-head'>Feedback</h3>
                        <p>“At Delight Consultancy, we view feedback as a vital tool for growth and improvement. We foster a culture of open, honest communication where feedback is both given and received constructively. Whether it’s positive recognition or areas for development, we believe that timely and actionable feedback helps individuals and teams perform at their best. Our commitment to continuous improvement means that we actively encourage feedback from all levels, allowing us to refine our approach, strengthen our collaboration, and consistently deliver the highest quality solutions. At Delight Consultancy, feedback is a key driver of both personal and organizational success.”</p>
                    </div>
                    <div className="col-md-6">
                        <h3 className='business-head'>Philanthropy</h3>
                        <p>“At Delight Consultancy, we are committed to giving back to the communities that have supported our growth. Our philanthropic efforts are rooted in the belief that businesses have a responsibility to contribute to the greater good. We actively support charitable causes, volunteer initiatives, and social impact projects that align with our values. Whether through direct donations, employee volunteer programs, or partnerships with local organizations, we strive to make a positive impact on society. By investing in philanthropy, we not only enhance the lives of others but also foster a sense of purpose and community within our own team.”</p>
                    </div>
                </div>
            </div>

        </div>
    );
};
export default Career;
